module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-aktuelles-c561776fbf3e4979c8d3f69656240e55.jpg";